// extracted by mini-css-extract-plugin
export default {"overlay":"bs-z","bodyOpen":"cs-z","content":"ds-z","header":"es-z","close":"fs-z","closeNoHeading":"gs-z"};